import { render, staticRenderFns } from "./HistoricoResumo.vue?vue&type=template&id=56ebd00b&scoped=true&"
import script from "./HistoricoResumo.vue?vue&type=script&lang=js&"
export * from "./HistoricoResumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ebd00b",
  null
  
)

export default component.exports